export type Environment =
  | "local"
  | "app.develop"
  | "app.staging"
  | "app.testing"
  | "app.prod"
  | "prod";

export type ConstantsMap<T> = Record<Environment, T>;

export const getEnv = (): Environment => {
  const host = window.location.host;

  if (host.includes("ops.develop.thespecsheet.com")) {
    return "app.develop";
  }

  if (host.includes("ops.testing.thespecsheet.com")) {
    return "app.testing";
  }

  if (host.includes("ops.staging.thespecsheet.com")) {
    return "app.staging";
  }

  if (host.includes("ops.prod.thespecsheet.com")) {
    return "app.prod";
  }

  if (host.includes("ops.thespecsheet.com")) {
    return "prod";
  }

  return "local";
};
